import styled from "styled-components"
import {themeModules} from "../../../theme/theme.js"
import {useSelector,useDispatch} from "react-redux"
import { useState } from "react"
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CloseIcon from '@mui/icons-material/Close';
import {formatFecha} from "../../../services/utilities.js"
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import api from '../../../axios.js'
import { estadoReventa } from "../../../redux/actions/reventaActions.js";

let Container=styled.div`
	height:92%;
	width:100%;
	display:flex;
	position:absolute;
	align-items:center;
	justify-content:center;
	left:0px;
	top:0px;

`;
let Overlay=styled.div`
	height:100%;
	width:100%;
	position:absolute;
	background-color:black;
	opacity:0.8;
	z-index:4
`;

let Content=styled.div`
	background-color:${themeModules.panel};
	border-radius:8px;
	height:80%;
	width:50%;
	z-index:5;
	display:flex;
	align-items:center;
	justify-content:center;
	flex-direction:column;
	opacity:1
`;

let ContainerAutoComplete=styled.div`
	display:flex;
	align-items:center;
	width:90%;
	justify-content:space-between;
	height:10%
`;

let ContainerUsuarioSelected=styled.div`
	height:90%;
	width:100%;
`;

let ContainerDataUser=styled.div`
	display:flex;
	height:100%;
	flex-direction:column;
	align-items:center;
	justify-content:space-evenly

`;

let Row=styled.div`
	display:flex;
	width:70%;
	justify-content:space-between
`;

let TituloRow=styled.div`
	font-weight:bold
`;

let ContainerButton=styled.div`

`;



export default function Revender(props){
	let {reventa,isOpen}=props;
	let usuariosRedux=useSelector(state=>state.usuario.usuarios);
	let [usuarioSelected,setUsuarioSelected]=useState();
	let dispatch=useDispatch();
	let defaultProps = {
    		options: usuariosRedux,
   			getOptionLabel: (option) => option.name,
  	};



  	let changeSelect=(event, newInputValue)=>{
  			setUsuarioSelected(newInputValue)
  	}
 
  	let saveNewReventa=async()=>{
  		let idReventa=reventa.id;
  		let idOldUser=reventa.UserId;
  		let idNewUser=usuarioSelected.id;
  	
  		if ( window.confirm("deseas grabar la venta de este juego?") ){				
				try{
					dispatch(estadoReventa(2))
					await api.post(`/reventa/sell?idReventa=${idReventa}&idOldUser=${idOldUser}&idNewUser=${idNewUser}`);					
					alert("datos agregados");
					dispatch(estadoReventa(0))
					isOpen(false)							
				}catch (err){
					console.error(err);
					
					alert("error al grabar los datos");
				};
		}
	}

	return(
		<Container>
			<Overlay/>
			<Content>
				<ContainerAutoComplete>
					<Autocomplete  sx={{ width: 400 }} {...defaultProps}  id="disable-close-on-select" onChange={changeSelect} disableClearable renderInput={(params) => (
          					<TextField {...params} label="selecionar usuario" variant="standard" />
        			)}/>
					<CloseIcon onClick={()=>isOpen(false)}/>
				</ContainerAutoComplete>
				<ContainerUsuarioSelected>
	{usuarioSelected?<ContainerDataUser>	
						<Row><TituloRow>Usuario :</TituloRow>{usuarioSelected.usuario}</Row>
						<Row><TituloRow>Nombre usuario :</TituloRow>{usuarioSelected.name}</Row>
						<Row><TituloRow>Correo usuario :</TituloRow>{usuarioSelected.correo}</Row>
						<Row><TituloRow>Telefono Usuario :</TituloRow>{usuarioSelected.telefono}</Row>
						<Row><TituloRow>Pais usuario :</TituloRow>{usuarioSelected.pais}</Row>
						<Row><TituloRow>Fecha de creacion :</TituloRow>{formatFecha(usuarioSelected.createdAt)}</Row>
						<ContainerButton>
							<Button variant="contained" endIcon={<SendIcon />} onClick={saveNewReventa}>
        							asignar
      						</Button>
      			</ContainerButton>
					</ContainerDataUser>:null}
				</ContainerUsuarioSelected>
			</Content>
		</Container>
	)
}